import { useParams } from "react-router-dom";
import { selectMatch, selectTournamentIdFromMatchId } from "selectors/Match";
import { ErrorMessagePage } from "pages/PageTemplates";
import { TournamentLoader } from "pages/TournamentLoader";
import { MatchPageContent } from "./MatchPageContent";
import { useAppSelector } from "app/hooks";

export const MatchPage = () => {
  const { id } = useParams();
  const tournamentId = useAppSelector((state) =>
    !!id ? selectTournamentIdFromMatchId(state, id) : undefined
  );

  const match = useAppSelector((state) => selectMatch(state, id));
  return (
    <TournamentLoader tournamentIds={!!tournamentId ? [tournamentId] : []}>
      {!!match && !!tournamentId ? (
        <MatchPageContent match={match} tournamentId={tournamentId} />
      ) : (
        <ErrorMessagePage message="Match Could Not Be Found" />
      )}
    </TournamentLoader>
  );
};
